import React from 'react'

const TitleWIthDescription = ({title1,title2,description}) => {
  return (
    <div className='m-2 p-2 py-8'>
      <div className='flex gap-2'>
      <h1 className='text-2xl sm:text-5xl font-semibold text-blue-900'>{title1}</h1>
      <h1  className='text-2xl sm:text-5xl font-semibold'>{title2}</h1>
      </div>
      <h2 className='text-gray-600 mt-4 text-md sm:text-xl'>{description}</h2>
    </div>
  )
}

export default TitleWIthDescription
